import React, { Component } from 'react'
import propTypes from 'prop-types'
import { PopOver } from '@/components/commons/PopOver'
import IconComponent from '@/components/commons/IconComponent'

import styles from './styles.scss'

/** Components */
import Input from '@/components/Input'
import InputNumber from '@/components/InputNumber'
import ColorPicker from '../../ColorPicker/index'

class Shadow extends Component {
  state = {
    active: false,
    shadow: {
      x: 0,
      y: 0,
      blur: 0,
      color: '#000'
    }
  }

  componentDidMount() {
    const { shadow } = this.props

    if (!shadow) return false


    const [x, y, blur, color] = shadow.split(' ')


    this.setState({
      shadow: {
        x: parseInt(x, 10),
        y: parseInt(y, 10),
        blur: parseInt(blur, 10),
        color
      }
    })
  }

  handleShadow = (type, value) => this.setState(prevState => ({
    shadow: {
      ...prevState.shadow,
      [type]: value
    }
  }), () => this.props.onChange(this.state.shadow))

  render() {
    const { active, shadow } = this.state

    return (
      <div className={styles['wrapper-box-shadow']}>
        <div className={styles['wrapper-box-shadow__button-color']}>
          <button onMouseDown={() => this.setState({ active: true })}>
            <span style={{ backgroundColor: shadow.color || '#000' }}></span>
            <IconComponent icon="down-arrow" />
          </button>
          <Input
            type="text"
            value={shadow.color}
            disabled={true}
          />
          {active && (
            <PopOver
              className={"color-popover " + styles['popover']}
              hidePopover={() => this.setState({ active: false })}
            >
              <ColorPicker
                color={shadow.color || '#000'}
                onChange={({ hex }) => this.handleShadow('color', hex)}
              />
            </PopOver>
          )}
        </div>

        <div className={styles['wrapper-box-shadow__content-slider']}>
          <div>
            <span>X</span>
            <InputNumber
              value={shadow.x}
              maxLength={3}
              onChange={({ target }) => {
                this.handleShadow('x', target.value)
              }}
            />
          </div>
          <div>
            <span>Y</span>
            <InputNumber
              value={shadow.y}
              maxLength={3}
              onChange={({ target }) => {
                this.handleShadow('y', target.value)
              }}
            />
          </div>
          <div>
            <span>B</span>
            <InputNumber
              value={shadow.blur}
              maxLength={3}
              onChange={({ target }) => {
                this.handleShadow('blur', target.value)
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

Shadow.propTypes = {
  shadow: propTypes.string,
  onChange: propTypes.func
}

Shadow.defaultProps = {
  shadow: '0px 0px 0px #000',
  onChange: () => { }
}

export default Shadow


// WEBPACK FOOTER //
// ./src/components/editors/BoxShadow/index.js